/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { EnumerableMap, EnumerableMapInterface } from "../EnumerableMap";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "EnumerableMapNonexistentKey",
    type: "error",
  },
] as const;

export class EnumerableMap__factory {
  static readonly abi = _abi;
  static createInterface(): EnumerableMapInterface {
    return new Interface(_abi) as EnumerableMapInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): EnumerableMap {
    return new Contract(address, _abi, runner) as unknown as EnumerableMap;
  }
}
